/* eslint-disable */
// @ts-nocheck

/* eslint-enable prettier/prettier */
/* eslint-enable @typescript-eslint/no-unused-vars */
/* eslint-enable import/no-unresolved */

import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import SubmitButton from "@untyped-shared/materialUI/buttons/submitButton";
import { useFormikContext } from "formik";
import { useLocalize } from "@untyped-shared/i18nProvider";

const useStyles = makeStyles(() => ({
  bulletPoint: {
    marginTop: "1px",
    marginLeft: "5px",
    float: "left",
    minHeight: "26px",
    minWidth: "26px",
    borderRadius: "50%",
    backgroundColor: "#4F8325",
  },
  buttonWrapper: {
    paddingBottom: "10px",
    marginLeft: "46px",
  },
  privacyNote: {
    fontSize: "1.2rem",
    marginTop: "4px",
  },
}));

function SurveySubmitButton() {
  const classes = useStyles();
  const { isSubmitting } = useFormikContext();
  const privacyPolicyLink = useLocalize("frontend.privacy_policy_link");
  const privacyNote = I18n.t("surveys.privacy_note", {
    privacy_policy_link: privacyPolicyLink,
  });

  return (
    <article className="comment-item last-item">
      <div className={`fa-stack ${classes.bulletPoint}`}>
        <i className="fa fa-check fa-stack-1x text-white" />
      </div>
      <section className={classes.buttonWrapper}>
        <SubmitButton disabled={isSubmitting} />
        <p
          className={classes.privacyNote}
          dangerouslySetInnerHTML={{ __html: privacyNote }}
        />
      </section>
    </article>
  );
}

export default SurveySubmitButton;
